import React from "react";
import "./coach-landing.css";

export default function CoachLandingPricingCompare() {
  const items = [
    { name: "Plan Pro (gestión de clientes)", note: "hasta 50 clientes · plan anual", price: "89€" },
    { name: "IA de nutrición", note: "add-on de pago aparte", price: "14,99€" },
    { name: "Biblioteca de vídeos", note: "add-on de ejercicios", price: "19,99€" },
    { name: "App de marca para tus clientes", note: "white-label", price: "24,99€" }
  ];

  const included = [
    "Gestión de clientes y planes",
    "IA de nutrición",
    "Librería de vídeos",
    "App para tus clientes y analíticas de negocio"
  ];

  return (
    <section className="pricing-compare-section" id="precio">
      <div className="container">
        <div className="compare-header">
          <div className="section-tag">El ahorro</div>
          <h2 className="section-title">Lo que pagas hoy vs lo que pagas con Wayo</h2>
          <p className="section-subtitle">
            Para tener gestión, IA de nutrición, vídeos y app de marca, las plataformas de pago
            suman fácil ~150&nbsp;€/mes. En Wayo va todo incluido — gratis.
          </p>
        </div>

        <div className="pc-grid">
          {/* Lo que pagas hoy */}
          <div className="pc-card">
            <div className="pc-card-head">
              <span className="pc-kicker">Lo que pagas hoy</span>
              <span className="pc-sub">Otras plataformas + sus extras</span>
            </div>
            <ul className="pc-list">
              {items.map((it, i) => (
                <li key={i} className="pc-li">
                  <span className="pc-name">
                    {it.name}
                    <small>{it.note}</small>
                  </span>
                  <span className="pc-price">{it.price}</span>
                </li>
              ))}
            </ul>
            <div className="pc-total">
              <span className="pc-total-label">
                Total mensual<small>coach individual</small>
              </span>
              <span className="pc-total-amount pc-red">
                ~149€<small>/mes</small>
              </span>
            </div>
          </div>

          {/* Con Wayo */}
          <div className="pc-card pc-card-wayo">
            <div className="pc-card-head">
              <span className="pc-kicker">Con Wayo Coach</span>
              <span className="pc-sub">Un solo plan, todo dentro</span>
            </div>
            <ul className="pc-list">
              {included.map((name, i) => (
                <li key={i} className="pc-li">
                  <span className="pc-name">{name}</span>
                  <span className="pc-price pc-inc">Incluido</span>
                </li>
              ))}
            </ul>
            <div className="pc-total">
              <span className="pc-total-label">
                Plan único<small>sin permanencia</small>
              </span>
              <span className="pc-total-amount pc-free">
                0€<small>/mes</small>
              </span>
            </div>
          </div>
        </div>

        <div className="pc-savings">
          <strong>Ahorras ~149€/mes con Wayo</strong>
          <span>
            {/* Hasta el 1-oct-2026 seguía «y encima ingresas por cada cliente que
                se pasa a Premium»: el coach no gana dinero con Wayo, solo ahorra. */}
            = 1.788€/año que dejas de pagar, sin límite de clientes y sin permanencia.
          </span>
        </div>
      </div>
    </section>
  );
}
